import React from "react";
import { Link } from "react-router-dom";
import { formatPrice, distanceLabel } from "../lib/locale";
import { TID } from "../constants/catalog";
import { MapPin } from "lucide-react";

export default function ListingCard({ listing, geoCountryCode }) {
  const hero = listing.images?.[0]?.url;
  const conditionColor =
    listing.condition?.startsWith("Working") ? "bg-[#34c759]/12 text-[#1c7c3a]"
    : listing.condition?.startsWith("Partially") ? "bg-[#ff9500]/15 text-[#a05c00]"
    : "bg-[#ff3b30]/12 text-[#a01d18]";

  return (
    <Link
      to={`/listing/${listing.listing_id}`}
      data-testid={TID.browse.cardLink(listing.listing_id)}
      className="group pbp-card flex flex-col"
    >
      <div className="aspect-[4/3] bg-[#f5f5f7] overflow-hidden">
        {hero ? (
          <img
            src={hero}
            alt={listing.model_number}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full grid place-items-center text-[#86868b] text-sm">No image</div>
        )}
      </div>
      <div className="p-4 md:p-5 flex-1 flex flex-col gap-2">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="text-xs uppercase tracking-wider text-[#86868b] font-medium">
              {listing.category} · {listing.year}
            </div>
            <div className="font-semibold text-[15px] md:text-base truncate">
              {listing.part_name === "Other" && listing.part_custom_text
                ? listing.part_custom_text
                : listing.part_name}
            </div>
            <div className="text-sm text-[#1d1d1f]/80 truncate">
              {listing.model_name ? `${listing.model_name} · ${listing.model_number}` : listing.model_number}
            </div>
          </div>
          <span className={`pbp-chip ${conditionColor} font-medium whitespace-nowrap`}>
            {listing.condition?.split(" ")[0]}
          </span>
        </div>
        {listing.seller_type && (
          <div className="text-[11px] uppercase tracking-wider text-[#0071e3] font-semibold">
            {listing.seller_type}
          </div>
        )}
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1 text-xs text-[#86868b]">
            <MapPin className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span className="truncate">{listing.city}, {listing.country}</span>
            {listing.distance_km != null && (
              <span className="text-[#0071e3] ml-1">· {distanceLabel(listing.distance_km, geoCountryCode)}</span>
            )}
          </div>
          <div className="font-semibold text-[#1d1d1f]">{formatPrice(listing.price, listing.currency)}</div>
        </div>
      </div>
    </Link>
  );
}
